import gql from "graphql-tag";

export const uploadFileMutation = gql`
  mutation uploadFile($input: UploadFile!) {
    uploadFile(input: $input) {
      url
      name
    }
  }
`;